/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseV2,
    PressReleaseV2FromJSON,
    PressReleaseV2FromJSONTyped,
    PressReleaseV2ToJSON,
} from './PressReleaseV2';

/**
 * 
 * @export
 * @interface SearchFollowingPressReleaseResponseData
 */
export interface SearchFollowingPressReleaseResponseData {
    /**
     * 
     * @type {Array<PressReleaseV2>}
     * @memberof SearchFollowingPressReleaseResponseData
     */
    pressReleases: Array<PressReleaseV2>;
    /**
     * 
     * @type {string}
     * @memberof SearchFollowingPressReleaseResponseData
     */
    nextCursor: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchFollowingPressReleaseResponseData
     */
    totalCount: number;
}

export function SearchFollowingPressReleaseResponseDataFromJSON(json: any): SearchFollowingPressReleaseResponseData {
    return SearchFollowingPressReleaseResponseDataFromJSONTyped(json, false);
}

export function SearchFollowingPressReleaseResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFollowingPressReleaseResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleases': ((json['press_releases'] as Array<any>).map(PressReleaseV2FromJSON)),
        'nextCursor': json['next_cursor'],
        'totalCount': json['total_count'],
    };
}

export function SearchFollowingPressReleaseResponseDataToJSON(value?: SearchFollowingPressReleaseResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_releases': ((value.pressReleases as Array<any>).map(PressReleaseV2ToJSON)),
        'next_cursor': value.nextCursor,
        'total_count': value.totalCount,
    };
}

